import React from 'react';

const ICON_ID = 'icon-external-link';

const IconExternalLink = function(props) {
  return (
    <svg width="9px" height="9px" viewBox="0 0 9 9" version="1.1" aria-labelledby={ICON_ID}>
        <title id={ICON_ID}>External Link Icon</title>
        <g id="Comps" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Desktop-Product-Recommendations-Saddle" transform="translate(-1038.000000, -1272.000000)" fillRule="nonzero" fill="#292929">
                <g id="retul-passport-icons-external-link-small" transform="translate(1038.000000, 1272.000000)">
                    <g id="Layer_1">
                        <g id="Group">
                            <path d="M8.685,2.205 L8.685,2.16 L9,0.18 C9,0.09 8.955,0.045 8.865,0.045 L6.885,0.315 C6.795,0.315 6.75,0.36 6.84,0.45 L7.38,0.99 L2.88,5.49 L3.555,6.165 L8.055,1.665 L8.595,2.205 C8.64,2.25 8.685,2.25 8.685,2.205 Z" id="Shape"></path>
                            <polygon id="Shape" points="8.37 4.14 8.37 8.37 0.63 8.37 0.63 0.63 4.86 0.63 4.86 0 0 0 0 9 9 9 9 4.14"></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}

export default IconExternalLink;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-external-link.jsx